import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20overlapping%20circles%20and%20geometric%20shapes%2C%20orange%20and%20warm%20beige%20tones%2C%20modern%20minimalist%20design%2C%20clean%20digital%20platform%20aesthetic%2C%20smooth%20curves%2C%20professional%20tech%20content%20platform%20atmosphere%2C%20no%20text%2C%20soft%20lighting%2C%20elegant%20composition&width=1800&height=900&seq=hero-bg-2026&orientation=landscape')`,
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 text-center">
        <h1 className="font-heading text-4xl md:text-6xl text-background-50 max-w-3xl leading-tight">
          随时随地畅享优质内容
        </h1>
        <p className="mt-6 text-base md:text-lg text-background-200 max-w-2xl leading-relaxed">
          久久在线是您最值得信赖的在线平台，提供海量优质内容资源，支持随时随地流畅访问。无论您身处何地，久久在线都能为您带来极致的在线体验。
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/category/shipin"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap"
          >
            立即探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-full border-2 border-background-50/40 text-background-50 font-semibold text-base hover:bg-background-50/15 transition-all whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-14 flex items-center gap-8">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">100万+</p>
            <p className="text-sm text-background-300 mt-1">优质内容</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">5000万+</p>
            <p className="text-sm text-background-300 mt-1">活跃用户</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">99.9%</p>
            <p className="text-sm text-background-300 mt-1">流畅稳定</p>
          </div>
        </div>
      </div>
    </section>
  );
}